<template>
    <div id="app">
        <transition :name="pageDirection" appear>
            <router-view class="child-view"></router-view>
        </transition>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'app',
    computed: {
        ...mapState([
            'pageDirection'
        ])
    },
    methods: {
        ...mapMutations([
            'afterEnter'
        ])
    },
    mounted() {
    }
}
</script>
<style>
.child-view {
    /*position: absolute;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*transition:all .5s;!* cubic-bezier(.55, 0, .1, 1) *!*/


  /*!*position: absolute;*!*/
  width: 100vw!important;
  height: 100vh!important;
  overflow: auto;
}
.mint-indicator-wrapper{z-index: 3000 !important;}
.mint-toast {z-index: 3001 !important;}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}
.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */
{
    opacity: 0
}
.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    transform: translate(5rem, 0);
}
.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    transform: translate(-5rem, 0);
}

body {
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// App.vue?193e8eb8